import pickBy from 'lodash/pickBy';

export const cleanObjectFromUndefined = (
  originalObject,
) => pickBy(originalObject, (v) => v !== undefined && v !== 'undefined' && v !== null && v !== 'null');

export default cleanObjectFromUndefined;
